import React from "react";
import { Link } from "react-router-dom";
import bgtwo from "../../../assets/images/background/bg-17.png";
import bgthree from "../../../assets/images/background/bg-18.png";
// import menutwo from "../../../assets/images/resource/menus-2.jpg";
import { menu } from "../../../Data/MenuItems";

function Startermenu() {
  return (
    <>
      {menu.map((menu) => ( 
        <section className="menu-one " dir={`${menu.dir.section}`}>
          <div className="left-bg">
            <img src={bgtwo} alt="" title="" />
          </div>
          <div className="right-bg-2">
            <img src={bgthree} alt="" title="" />
          </div>
          <div className="auto-container">
            <div className="title-box centered">
              <div className="subtitle">
                <span>TREAT YOURSELF</span>
              </div>

              <div className="pattern-image">
                <img
                  src={
                    require("../../../assets/images/icons/separator.svg")
                      .default
                  }
                  alt="mySvgImage"
                />
              </div>

              <h2>{menu.category}</h2>
            </div>

            <div className="row clearfix">
              <div className="image-col col-lg-7 col-md-12 col-sm-12">
                <div className="inner">
                  <div className="image">
                    <img src={menu.image} alt="" />
                  </div>
                </div>
              </div>
              <div className="menu-col col-lg-5 col-md-12 col-sm-12 ItemsScrollbar">
                <div className="inner" dir={`${menu.dir.inner}`} >
                  {menu.items.map((items) => (
                    <div className="dish-block">
                      <div className="inner-box">
                        <div className="title clearfix">
                          <div className="ttl clearfix">
                            <h5>
                              <Link to="#" style={{textTransform:'uppercase'}}>{items.name}</Link>
                            </h5>
                          </div>
                          <div className="price">
                            <span>₹{items.price}</span>
                          </div>
                        </div>
                        {/* <div className="text desc">
                          <Link to="#">
                            Tomatoes, green bell pepper, sliced cucumber onion,
                            olives, and feta cheese.
                          </Link>
                        </div> */}
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </section>
      ))}
    </>
  );
}

export default Startermenu;
